import React from "react";
import { useTranslation } from "react-i18next";

const StepsIndicator = ({
  currentStep,
  totalSteps,
  title = "Complete your registration",
  content = "Let’s finalize the details to prepare your store for a quick launch.",
}) => {
  const { t, i18n } = useTranslation();
  return (
    <div className="w-full p-8 bg-white rounded-2xl flex flex-col gap-2">
      <div className="text-16px font-semibold gap-1 flex items-center">
        <span className="text-midnight-slate">{t(title)}</span>
        <span className="text-bright-blue">
          {t("Step step of totalSteps", {
            step: currentStep,
            totalSteps: totalSteps,
          })}
        </span>
      </div>
      <div className="w-full h-1 bg-theme-blue-light-2 relative rounded-md">
        <div
          className="absolute -top-1/2 h-2 bg-bright-blue rounded-md transition-all duration-300"
          style={{
            width: `${(currentStep / totalSteps) * 100}%`,
            left: i18n.language === "ar" ? "auto" : 0,
            right: i18n.language === "ar" ? 0 : "auto",
          }}
        />
      </div>

      <div className="text-slate-400 text-16px">{t(content)}</div>
    </div>
  );
};
export default StepsIndicator;
